goog.provide("shadow.js.shim.module$$mui$material$Alert");
goog.provide("module$shadow_js_shim_module$$mui$material$Alert");
shadow.js.shim.module$$mui$material$Alert = shadow.js.nativeProvides["@mui/material/Alert"] = shadow$bridge("@mui/material/Alert");
module$shadow_js_shim_module$$mui$material$Alert.default = shadow.js.shim.module$$mui$material$Alert;
